// @ts-nocheck
import { createHandlerChainRunner, ApiHandlerDiscreteParameter } from "@insite/client-framework/HandlerCreator";
import { GetRelatedProductCollectionApiV2Parameter } from "@insite/client-framework/Services/ProductServiceV2";
import loadProductInfoList from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";
import { LoadProductInfoListParameter } from "@store/Extensions/Store/Components/ProductInfoList/Handlers/LoadProductInfoList";

export interface LoadAccessoryUpsellParameter {
    id: string;
    isShellEdit?: boolean;
    productId: string;
    warehouse?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<LoadAccessoryUpsellParameter, GetRelatedProductCollectionApiV2Parameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        productId: props.parameter.productId,
        relationship: "Accessory",
        pageSize: 1,
        expand: ["images"],
    };
};

export const LoadProducts: HandlerType = props => {
    props.dispatch(
        loadProductInfoList({
            id: props.parameter.id,
            getProductCollectionParameter: props.apiParameter,
            isShellEdit: props.parameter.isShellEdit,
            warehouse: props.parameter.warehouse,
        } as LoadProductInfoListParameter),
    );
};

export const chain = [PopulateApiParameter, LoadProducts];

const loadAccessoriesUpsell = createHandlerChainRunner(chain, "AccessoriesUpsellHandler");
export default loadAccessoriesUpsell;
